import { LoggedInUserInterface } from '../interfaces'
import { TokenUserId, TokenRoles } from '../interfaces/LoggedInUserInterface';
import { errorHandler } from './index'

class JwtData {
  userData: LoggedInUserInterface = {
    userId: '',
    name: '',
    family: '',
    token: '',
    currentPharmacyKey: '',
    imageKey: '',
    pharmacyName: '',
    gender: 0,
    pharmacyCity: '',
    pharmacyProvince: '',
    mobile: '',
    pharmacyCode:''
  }

  parsedToken: any = {
    TokenRoles: [],
    TokenUserData: '',
    TokenUserId: '',
  }

  parseJwt = (token: string): any => {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''),
    )

    return JSON.parse(jsonPayload)
  }

  constructor() {
    try {
      const userFromStorage = localStorage.getItem('user')
      if (!userFromStorage) {
        errorHandler('user token is null')
        return
      }
      const userFromStorageJSON = JSON.parse(userFromStorage)
      this.userData = {
        userId: 0,
        name: userFromStorageJSON.name,
        family: userFromStorageJSON.family,
        token: userFromStorageJSON.token,
        imageKey: userFromStorageJSON.imageKey,
        pharmacyName: userFromStorageJSON.pharmacyName,
        currentPharmacyKey: userFromStorageJSON.currentPharmacyKey,
        pharmacyCity: userFromStorageJSON.pharmacyCity,
        pharmacyCode: userFromStorageJSON.pharmacyCode,
        pharmacyProvince: userFromStorageJSON.pharmacyProvince,
        mobile: userFromStorageJSON.mobile,
        gender: userFromStorageJSON.gender,
      }
      this.parsedToken = this.parseJwt(this.userData.token)
      this.userData.userId = this.parsedToken[TokenUserId] ?? 0
    } catch (e) {
      errorHandler(e)
    }
  }

  roles = (): any => {
    let rolesArray = this.parsedToken[TokenRoles]
    if (!Array.isArray(rolesArray)) {
      rolesArray = [rolesArray]
    }
    return rolesArray
  }

  /// If admin used impersonation and we want
  /// admin's roles not the impersonated pharmacy's roles
  rolesFromMainToken = (): any => {
    const mainToken = localStorage.getItem('mainToken')
    if (!mainToken) return []

    let rolesArray = this.parseJwt(mainToken)[TokenRoles]
    if (!Array.isArray(rolesArray)) {
      rolesArray = [rolesArray]
    }
    return rolesArray
  }
}

export default JwtData
